// extracted by mini-css-extract-plugin
module.exports = {"icon":"styles_icon__e9pOF","negative":"styles_negative__2QBBI","positive":"styles_positive__xQkbA","filled":"styles_filled__t_4oi"};